"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_hanger_1 = require("react-hanger");
const react_helmet_1 = tslib_1.__importDefault(require("react-helmet"));
const react_if_1 = require("react-if");
const context_1 = require("../context");
const navs_1 = require("./navs");
const Router_1 = require("./Router");
const index_1 = require("./AppLoader/index");
const ErrorBoundary_1 = require("./ErrorBoundary");
const react_2 = require("@osmosys/react");
const logrocket_1 = tslib_1.__importDefault(require("logrocket"));
const react_use_1 = require("react-use");
const models_1 = require("@osmosys/models");
const hooks_1 = require("../hooks");
if (window.location.hostname !== '127.0.0.1') {
    logrocket_1.default.init('01ywmv/new-osmosys');
}
const Analytics = () => {
    const [hasStarted] = react_use_1.useTimeout(1000);
    return hasStarted() ? react_1.default.createElement(AnalyticsInner, null) : null;
};
const AnalyticsInner = () => {
    react_hanger_1.useLogger('Analytics', {});
    hooks_1.useAnalytics();
    return null;
};
exports.App = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { state, setState } = react_hanger_1.useSetState({
        contextData: context_1.osmosysAppDefault,
    });
    const appSettings = (_a = state.contextData) === null || _a === void 0 ? void 0 : _a.appSettings;
    const currentUser = (_b = state.contextData) === null || _b === void 0 ? void 0 : _b.currentUser;
    const currentWorkspace = (_e = (_d = (_c = state.contextData) === null || _c === void 0 ? void 0 : _c.currentUser) === null || _d === void 0 ? void 0 : _d.currentWorkspaceMembership) === null || _e === void 0 ? void 0 : _e.workspace;
    const currentWorkspaceMembership = (_g = (_f = state.contextData) === null || _f === void 0 ? void 0 : _f.currentUser) === null || _g === void 0 ? void 0 : _g.currentWorkspaceMembership;
    const isLoggedIn = !!currentUser;
    const mode = !currentUser
        ? 'anonymous'
        : !currentWorkspace || !currentWorkspaceMembership
            ? 'setup'
            : 'private';
    // Cheap trick to have Safari redirect to https
    react_use_1.useEffectOnce(() => {
        if (window.location.protocol === 'http:' &&
            window.location.hostname.includes('osmosys.')) {
            window.location.href = window.location.href.replace('http:', 'https:');
        }
    });
    // Feature Flags
    // const { featureFlags, updateFeatureFlags } = useFeatureFlags();
    // Listen for updates
    const updateOsmosysContext = react_1.useCallback((c) => {
        const newContext = Object.assign(Object.assign({}, state.contextData), c);
        setState({
            contextData: Object.assign({}, newContext),
        });
        return newContext;
    }, [state.contextData, setState]);
    const featureFlags = react_1.useMemo(() => {
        var _a, _b, _c;
        return Object.assign(Object.assign(Object.assign({}, models_1.dropNullFeatureFlags((_a = appSettings) === null || _a === void 0 ? void 0 : _a.featureFlagOverrides)), models_1.dropNullFeatureFlags((_b = currentWorkspace) === null || _b === void 0 ? void 0 : _b.featureFlagOverrides)), models_1.dropNullFeatureFlags((_c = currentUser) === null || _c === void 0 ? void 0 : _c.featureFlagOverrides));
    }, [
        (_h = appSettings) === null || _h === void 0 ? void 0 : _h.featureFlagOverrides,
        (_j = currentWorkspace) === null || _j === void 0 ? void 0 : _j.featureFlagOverrides,
        (_k = currentUser) === null || _k === void 0 ? void 0 : _k.featureFlagOverrides,
    ]);
    const switchAdminRole = react_1.useCallback(role => updateOsmosysContext({
        adminRole: role,
    }), [updateOsmosysContext]);
    return (react_1.default.createElement(context_1.OsmosysAppUpdateContext.Provider, { value: {
            switchAdminRole,
            updateOsmosysContext,
        } },
        react_1.default.createElement(context_1.OsmosysAppContext.Provider, { value: Object.assign(Object.assign({}, state.contextData), { currentUser,
                currentWorkspace,
                currentWorkspaceMembership,
                featureFlags,
                isLoggedIn,
                mode }) },
            react_1.default.createElement(Analytics, null),
            react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, null,
                react_1.default.createElement(react_helmet_1.default, { defaultTitle: "Osmosys", titleTemplate: "%s | Osmosys" }),
                react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, null,
                    react_1.default.createElement(navs_1.AppNav, null)),
                react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, null,
                    react_1.default.createElement(react_2.OsmosysDiv, { osysName: "App.innerContainer", className: "position-relative overflow-y-hidden", flexColFilled: true },
                        react_1.default.createElement(react_2.OsmosysDiv, { osysName: "App.inner", className: "osmosys-scroll-container overflow-y-auto position-relative", flexColFilled: true },
                            react_1.default.createElement(index_1.AppLoader, null),
                            react_1.default.createElement(react_if_1.When, { condition: state.contextData.appHasLoaded }, () => {
                                return react_1.default.createElement(Router_1.Router, null);
                            })),
                        react_1.default.createElement(react_2.OsmosysDiv, { id: "osmosys-toasts", className: "rounded position-absolute", style: {
                                bottom: 0,
                                right: 0,
                                zIndex: 10 * 100 * 1000 * 1000 * 1000,
                            } }),
                        react_1.default.createElement(react_2.OsmosysDiv, { id: "app-side-bar" }))),
                react_1.default.createElement(react_2.OsmosysDiv, { className: "app-footer", style: {
                        zIndex: 10 * 100 * 1001,
                    }, flexCol: true },
                    react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
                        react_1.default.createElement(react_2.OsmosysDiv, { flexColFilled: true, id: "alert-portal", className: "mx-2" })),
                    react_1.default.createElement(react_2.OsmosysDiv, { flexCol: true },
                        react_1.default.createElement("div", { id: "footer-portal", className: "flex-shrink-1 w-100" })))))));
};
//# sourceMappingURL=App.js.map